<!-- Start Course Calendar Section -->
<section class="ecb-course-calendar-section">

    <div class="container-fluid ecb-course-calendar-container">

        <!-- Start Page Header -->
        <header class="ecb-course-calendar-page-header">

            <div class="ecb-course-calendar-page-title">

                <span class="ecb-course-calendar-title-icon">
                    <i class="bi bi-calendar3" aria-hidden="true"></i>
                </span>

                <div>
                    <h1>Course Calendar</h1>
                    <p>View and book upcoming training courses</p>
                </div>

            </div>


            <!-- Start Calendar Controls -->
            <div class="ecb-course-calendar-controls">

                <button type="button" class="ecb-course-calendar-control-button ecb-course-calendar-today-button"
                    (click)="goToToday()">
                    Today
                </button>


                <div class="ecb-course-calendar-navigation">

                    <button type="button" class="ecb-course-calendar-control-button ecb-course-calendar-icon-button"
                        aria-label="Previous calendar period" (click)="navigateCalendar('previous')">

                        <i class="bi bi-chevron-left" aria-hidden="true"></i>

                    </button>


                    <button type="button" class="ecb-course-calendar-control-button ecb-course-calendar-icon-button"
                        aria-label="Next calendar period" (click)="navigateCalendar('next')">

                        <i class="bi bi-chevron-right" aria-hidden="true"></i>

                    </button>

                </div>


                <div class="ecb-course-calendar-view-switcher">

                    <button type="button"
                        [class.ecb-course-calendar-view-active]="activeCalendarView === 'dayGridMonth'"
                        (click)="changeCalendarView('dayGridMonth')">
                        Month
                    </button>

                    <button type="button"
                        [class.ecb-course-calendar-view-active]="activeCalendarView === 'timeGridWeek'"
                        (click)="changeCalendarView('timeGridWeek')">
                        Week
                    </button>

                    <button type="button" [class.ecb-course-calendar-view-active]="activeCalendarView === 'timeGridDay'"
                        (click)="changeCalendarView('timeGridDay')">
                        Day
                    </button>

                </div>


                <button type="button" class="ecb-course-calendar-control-button ecb-course-calendar-filter-toggle"
                    aria-label="Show or hide course filters" [attr.aria-expanded]="isFilterPanelOpen"
                    (click)="toggleFilterPanel()">

                    <i class="bi bi-funnel" aria-hidden="true"></i>

                </button>

            </div>
            <!-- End Calendar Controls -->

        </header>
        <!-- End Page Header -->


        <!-- Start Main Layout -->
        <div class="ecb-course-calendar-layout" [class.ecb-course-calendar-layout-no-sidebar]="!isFilterPanelOpen">

            <!-- Start Sidebar -->
            <aside class="ecb-course-calendar-sidebar" *ngIf="isFilterPanelOpen">

                <!-- Start Filters Card -->
                <section class="ecb-course-calendar-filter-card">

                    <div class="ecb-course-calendar-card-heading">

                        <h2>Filters</h2>

                        <button type="button" (click)="clearAllFilters()">
                            Clear All
                        </button>

                    </div>


                    <div class="ecb-course-calendar-filter-group">

                        <h3>Course Type</h3>

                        <label class="ecb-course-calendar-checkbox-row" *ngFor="
                                let courseType of courseTypeFilters;
                                trackBy: trackByCourseTypeId
                            ">

                            <input type="checkbox" [checked]="courseType.selected"
                                (change)="toggleCourseType(courseType.id)">

                            <span class="ecb-course-calendar-checkbox-box">
                                <i class="bi bi-check" aria-hidden="true"></i>
                            </span>

                            <span class="ecb-course-calendar-filter-dot" [style.background-color]="courseType.color">
                            </span>

                            <span class="ecb-course-calendar-filter-name">
                                {{ courseType.label }}
                            </span>

                            <small>
                                {{ courseType.count }}
                            </small>

                        </label>

                    </div>


                    <div class="ecb-course-calendar-filter-group">

                        <label for="ecb-course-location">
                            Location
                        </label>

                        <div class="ecb-course-calendar-select-wrapper">

                            <select id="ecb-course-location" [value]="selectedLocation"
                                (change)="updateLocation($event)">

                                <option value="all">
                                    All Locations
                                </option>

                                <option *ngFor="let location of locationOptions" [value]="location">
                                    {{ location }}
                                </option>

                            </select>

                            <i class="bi bi-chevron-down" aria-hidden="true"></i>

                        </div>

                    </div>


                    <!--   <div class="ecb-course-calendar-filter-group">

                        <label for="ecb-course-date-range">
                            Date Range
                        </label>

                        <div class="ecb-course-calendar-select-wrapper">

                            <select id="ecb-course-date-range" [value]="selectedDateRange"
                                (change)="updateDateRange($event)">

                                <option value="this-month">
                                    This Month
                                </option>

                                <option value="next-30">
                                    Next 30 Days
                                </option>

                                <option value="next-90">
                                    Next 90 Days
                                </option>

                                <option value="all">
                                    All Dates
                                </option>

                            </select>

                            <i class="bi bi-chevron-down" aria-hidden="true"></i>

                        </div>

                    </div> -->


                    <button type="button" class="ecb-course-calendar-apply-button" (click)="applyFilters()">
                        Apply Filters
                    </button>

                </section>
                <!-- End Filters Card -->


                <!-- Start Upcoming Courses Card -->
                <!--    <section class="ecb-course-calendar-upcoming-card">

                    <h2>Upcoming Courses</h2>


                    <button type="button" class="ecb-course-calendar-upcoming-item" *ngFor="
                            let course of upcomingCourses;
                            trackBy: trackByCourseId
                        " (click)="openCourseDetails(course)">

                        <span class="ecb-course-calendar-upcoming-dot"
                            [style.background-color]="course.backgroundColor">
                        </span>

                        <span class="ecb-course-calendar-upcoming-content">

                            <strong>
                                {{ course.extendedProps.courseName }}
                            </strong>

                            <small>
                                {{ formatUpcomingDate(course.start) }}
                                <span>•</span>
                                {{ course.extendedProps.location }}
                            </small>

                        </span>

                        <span class="ecb-course-calendar-seat-badge">
                            {{ course.extendedProps.vacancies }} seats left
                        </span>

                    </button>


                    <div class="ecb-course-calendar-upcoming-empty" *ngIf="upcomingCourses.length === 0">

                        No upcoming courses match the selected filters.

                    </div>


                    <button type="button" class="ecb-course-calendar-view-upcoming-button"
                        *ngIf="filteredCourses.length > 3" (click)="toggleUpcomingCourses()">

                        {{
                        showAllUpcomingCourses
                        ? 'Show fewer'
                        : 'View all upcoming'
                        }}

                        <i class="bi" [class.bi-arrow-right]="!showAllUpcomingCourses"
                            [class.bi-arrow-up]="showAllUpcomingCourses" aria-hidden="true">
                        </i>

                    </button>

                </section> -->
                <!-- End Upcoming Courses Card -->

            </aside>
            <!-- End Sidebar -->


            <!-- Start Calendar Content -->
            <main class="ecb-course-calendar-main">

                <section class="ecb-course-calendar-card">

                    <h2 class="ecb-course-calendar-current-title">
                        {{ calendarTitle }}
                    </h2>

                    <div class="ecb-course-calendar-scroll">

                        <full-calendar #courseCalendar [options]="calendarOptions">
                        </full-calendar>

                    </div>

                </section>

            </main>
            <!-- End Calendar Content -->

        </div>
        <!-- End Main Layout -->


        <!-- Start Booking Benefits -->
        <footer class="ecb-course-calendar-benefits">

            <div class="ecb-course-calendar-benefit-item">

                <span>
                    <i class="bi bi-calendar-check" aria-hidden="true"></i>
                </span>

                <div>
                    <strong>Real-time availability</strong>
                    <small>Powered by VETEnrol</small>
                </div>

            </div>


            <div class="ecb-course-calendar-benefit-item">

                <span>
                    <i class="bi bi-ticket-perforated" aria-hidden="true"></i>
                </span>

                <div>
                    <strong>Instant confirmation</strong>
                    <small>Get booked in seconds</small>
                </div>

            </div>


            <div class="ecb-course-calendar-benefit-item">

                <span>
                    <i class="bi bi-shield-lock" aria-hidden="true"></i>
                </span>

                <div>
                    <strong>Secure booking</strong>
                    <small>Your data is protected</small>
                </div>

            </div>


            <div class="ecb-course-calendar-benefit-item">

                <span>
                    <i class="bi bi-telephone" aria-hidden="true"></i>
                </span>

                <div>
                    <small>Need help? Call us</small>

                    <a href="tel:0893580000">
                        1300 322 486
                    </a>
                </div>

            </div>

        </footer>
        <!-- End Booking Benefits -->

    </div>

</section>
<!-- End Course Calendar Section -->


<!-- Start Course Booking Modal -->
<div class="ecb-course-booking-overlay" *ngIf="isCourseModalOpen && selectedShortCourse" (click)="closeCourseModal()">

    <section class="ecb-course-booking-modal" role="dialog" aria-modal="true" aria-labelledby="ecb-course-booking-title"
        (click)="$event.stopPropagation()">


        <!-- Start Close Icon -->
        <button type="button" class="ecb-course-booking-close-icon" aria-label="Close course details"
            (click)="closeCourseModal()">

            <i class="bi bi-x-lg" aria-hidden="true"></i>

        </button>
        <!-- End Close Icon -->


        <!-- Start Modal Main Content -->
        <div class="ecb-course-booking-content">

            <!-- Start Heading -->
            <header class="ecb-course-booking-heading">

                <h2 id="ecb-course-booking-title">
                    {{ selectedShortCourse.title }}
                </h2>

                <span class="ecb-course-booking-category">
                    {{ selectedCourseModalDetails.category }}
                </span>

                <p>
                    {{ selectedShortCourse.description }}
                </p>

            </header>
            <!-- End Heading -->


            <!-- Start Course Summary -->
            <section class="ecb-course-booking-summary">

                <div class="ecb-course-booking-summary-item">

                    <span class="ecb-course-booking-summary-icon">
                        <i class="bi bi-calendar-check" aria-hidden="true"></i>
                    </span>

                    <div>
                        <small>Assessment</small>

                        <strong>
                            {{ selectedCourseModalDetails.assessment }}
                        </strong>
                    </div>

                </div>


                <div class="ecb-course-booking-summary-item">

                    <span class="ecb-course-booking-summary-icon">
                        <i class="bi bi-clock" aria-hidden="true"></i>
                    </span>

                    <div>
                        <small>Duration</small>

                        <strong>
                            {{ selectedCourseModalDetails.duration }}
                        </strong>
                    </div>

                </div>

            </section>
            <!-- End Course Summary -->


            <!-- Start Information Rows -->
            <section class="ecb-course-booking-information">

                <div class="ecb-course-booking-information-row">

                    <span>Registrations Close</span>

                    <strong>
                        {{
                        selectedShortCourse.registrationCloseDate
                        | date: 'dd MMM yyyy'
                        }}
                    </strong>

                </div>


                <div class="ecb-course-booking-information-row">

                    <span>Course Dates</span>

                    <strong>

                        {{
                        selectedShortCourse.startDate
                        | date: 'dd/MM/yyyy'
                        }}

                        <ng-container *ngIf="
                                selectedShortCourse.endDate &&
                                selectedShortCourse.endDate !==
                                selectedShortCourse.startDate
                            ">

                            to

                            {{
                            selectedShortCourse.endDate
                            | date: 'dd/MM/yyyy'
                            }}

                        </ng-container>

                    </strong>

                </div>


                <div class="ecb-course-booking-information-row">

                    <span>Vacancies</span>

                    <strong class="ecb-course-booking-vacancies" [class.ecb-course-booking-no-vacancies]="
                            selectedShortCourse.vacancies === 0
                        ">

                        {{
                        selectedShortCourse.vacancies > 0
                        ? selectedShortCourse.vacancies +
                        ' Seats Available'
                        : 'Fully Booked'
                        }}

                    </strong>

                </div>


                <div class="ecb-course-booking-information-row">

                    <span>Location</span>

                    <button type="button" class="ecb-course-booking-location" [disabled]="
            !selectedShortCourse.address &&
            !selectedShortCourse.location
        " (click)="openLocationMap()">

                        <i class="bi bi-geo-alt" aria-hidden="true">
                        </i>

                        <span>
                            {{ selectedShortCourse.location }}
                        </span>

                        <i class="bi bi-box-arrow-up-right ecb-course-location-open-icon" aria-hidden="true">
                        </i>

                    </button>

                </div>


                <!-- Start Classes Row -->
                <div class="ecb-course-booking-information-row">

                    <span>Classes</span>

                    <button type="button" class="ecb-course-booking-link-value ecb-course-booking-details-trigger"
                        (click)="openClassesModal()">

                        <span>
                            {{ selectedCourseClasses.length }}
                        </span>

                        <span>Available Sessions</span>

                        <i class="bi bi-chevron-right" aria-hidden="true">
                        </i>

                    </button>

                </div>
                <!-- End Classes Row -->


                <!-- Start Units Row -->
                <div class="ecb-course-booking-information-row">

                    <span>Units</span>

                    <button type="button" class="ecb-course-booking-link-value ecb-course-booking-details-trigger"
                        (click)="openUnitsModal()">

                        <span>
                            {{ selectedCourseUnits.length }}
                        </span>

                        <span>Unit Details</span>

                        <i class="bi bi-chevron-right" aria-hidden="true">
                        </i>

                    </button>

                </div>
                <!-- End Units Row -->

            </section>
            <!-- End Information Rows -->


            <!-- Start Price and Booking Panel -->
            <section class="ecb-course-booking-payment-panel">

                <!-- Start Booking Summary -->
                <div *ngIf="!isShowingPaymentForm">

                    <div class="ecb-course-booking-price-row">

                        <span>
                            Course Fee (per participant)
                        </span>

                        <strong>
                            {{
                            selectedShortCourse.amount
                            | currency:
                            'AUD':
                            'symbol':
                            '1.2-2'
                            }}
                        </strong>

                    </div>


                    <div class="ecb-course-booking-total-row">

                        <span>
                            <strong>Total</strong>
                            <small>(GST Inclusive)</small>
                        </span>

                        <strong>
                            {{
                            selectedShortCourse.amount
                            | currency:
                            'AUD':
                            'symbol':
                            '1.2-2'
                            }}
                        </strong>

                    </div>


                    <div class="ecb-course-booking-actions">

                        <button type="button" class="ecb-course-booking-group-button"
                            (click)="openGroupBookingEnquiry()">

                            <i class="bi bi-people" aria-hidden="true"></i>

                            Group Booking

                        </button>


                        <button type="button" class="ecb-course-booking-now-button" [disabled]="
                                selectedShortCourse.vacancies === 0 ||
                                selectedShortCourse.expired
                            " (click)="openCourseEnrolment()">

                            <i class="bi bi-calendar3" aria-hidden="true"></i>

                            {{
                            selectedShortCourse.expired
                            ? 'Registration Closed'
                            : 'Book Now'
                            }}

                        </button>

                    </div>

                </div>
                <!-- End Booking Summary -->


                <!-- Start Payment Customer Form -->
                <div class="ecb-course-payment-form-wrapper" *ngIf="isShowingPaymentForm">

                    <div class="ecb-course-payment-form-heading">

                        <div>
                            <h3>Participant Details</h3>

                            <p>
                                Enter the participant details before proceeding
                                with the payment.
                            </p>
                        </div>

                        <button type="button" class="ecb-course-payment-back-button" (click)="closePaymentForm()">

                            <i class="bi bi-arrow-left" aria-hidden="true"></i>

                            Back

                        </button>

                    </div>


                    <form #paymentFormRef="ngForm" class="ecb-course-payment-form"
                        (ngSubmit)="submitCoursePayment(paymentFormRef)" novalidate>

                        <!-- Start Given Name -->
                        <div class="ecb-course-payment-form-row">

                            <label for="ecb-payment-given-name">
                                Given Name:
                                <span>*</span>
                            </label>

                            <div class="ecb-course-payment-field">

                                <input id="ecb-payment-given-name" type="text" name="givenName"
                                    [(ngModel)]="paymentCustomer.givenName" #givenName="ngModel"
                                    autocomplete="given-name" required>

                                <small class="ecb-course-payment-error" *ngIf="
                                        givenName.invalid &&
                                        (
                                            givenName.touched ||
                                            paymentFormRef.submitted
                                        )
                                    ">

                                    Given name is required.

                                </small>

                            </div>

                        </div>
                        <!-- End Given Name -->


                        <!-- Start Family Name -->
                        <div class="ecb-course-payment-form-row">

                            <label for="ecb-payment-family-name">
                                Family:

                            </label>

                            <div class="ecb-course-payment-field">

                                <input id="ecb-payment-family-name" type="text" name="familyName"
                                    [(ngModel)]="paymentCustomer.familyName" #familyName="ngModel"
                                    autocomplete="family-name">

                                <!--    <small class="ecb-course-payment-error" *ngIf="
                                        familyName.invalid &&
                                        (
                                            familyName.touched ||
                                            paymentFormRef.submitted
                                        )
                                    ">

                                    Family or single name is required.

                                </small> -->

                            </div>

                        </div>
                        <!-- End Family Name -->


                        <!-- Start Email -->
                        <div class="ecb-course-payment-form-row">

                            <label for="ecb-payment-email">
                                Email:
                                <span>*</span>
                            </label>

                            <div class="ecb-course-payment-field">

                                <input id="ecb-payment-email" type="email" name="email"
                                    [(ngModel)]="paymentCustomer.email" #email="ngModel" autocomplete="email" required
                                    email>

                                <small class="ecb-course-payment-error" *ngIf="
                                        email.errors?.['required'] &&
                                        (
                                            email.touched ||
                                            paymentFormRef.submitted
                                        )
                                    ">

                                    Email address is required.

                                </small>

                                <small class="ecb-course-payment-error" *ngIf="
                                        email.errors?.['email'] &&
                                        (
                                            email.touched ||
                                            paymentFormRef.submitted
                                        )
                                    ">

                                    Enter a valid email address.

                                </small>

                            </div>

                        </div>
                        <!-- End Email -->


                        <!-- Start Payment Summary -->
                        <div class="ecb-course-payment-summary">

                            <div>
                                <span>Course</span>

                                <strong>
                                    {{ selectedShortCourse.courseCode }}
                                    -
                                    {{ selectedShortCourse.courseName }}
                                </strong>
                            </div>

                            <div>
                                <span>Total Payment</span>

                                <strong>
                                    {{
                                    selectedShortCourse.amount
                                    | currency:
                                    'AUD':
                                    'symbol':
                                    '1.2-2'
                                    }}
                                </strong>
                            </div>

                        </div>
                        <!-- End Payment Summary -->


                        <!-- Start Payment Actions -->
                        <div class="ecb-course-payment-form-actions">

                            <button type="button" class="btn ecb-course-payment-cancel-button"
                                (click)="closePaymentForm()">
                                Cancel
                            </button>

                            <button type="submit" class="btn ecb-course-payment-pay-button" (click)="payNow()"
                                [disabled]="isPaymentSubmitting">

                                <i class="bi bi-lock-fill" aria-hidden="true"></i>

                                {{
                                isPaymentSubmitting
                                ? 'Processing...'
                                : 'Pay ' +
                                (
                                selectedShortCourse.amount
                                | currency:
                                'AUD':
                                'symbol':
                                '1.2-2'
                                )
                                }}

                            </button>

                        </div>
                        <!-- End Payment Actions -->

                    </form>

                </div>
                <!-- End Payment Customer Form -->

            </section>
            <!-- End Price and Booking Panel -->

        </div>
        <!-- End Modal Main Content -->


        <!-- Start Modal Footer -->
        <footer class="ecb-course-booking-footer">

            <button type="button" (click)="closeCourseModal()">
                Close
            </button>

        </footer>
        <!-- End Modal Footer -->

    </section>

</div>
<!-- End Course Booking Modal -->


<!-- Start Course Location Map Modal -->
<div class="ecb-course-map-overlay" *ngIf="isMapModalOpen" (click)="closeLocationMap()">

    <section class="ecb-course-map-modal" role="dialog" aria-modal="true" aria-labelledby="ecb-course-map-title"
        (click)="$event.stopPropagation()">

        <header class="ecb-course-map-header">

            <div>

                <h3 id="ecb-course-map-title">
                    Course Location
                </h3>

                <p>
                    {{ selectedMapAddress }}
                </p>

            </div>


            <button type="button" class="ecb-course-map-close-button" aria-label="Close location map"
                (click)="closeLocationMap()">

                <i class="bi bi-x-lg" aria-hidden="true">
                </i>

            </button>

        </header>


        <div class="ecb-course-map-frame-wrapper">

            <iframe *ngIf="mapEmbedUrl" [src]="mapEmbedUrl" title="Course location on Google Maps" loading="lazy"
                allowfullscreen referrerpolicy="no-referrer-when-downgrade">
            </iframe>

        </div>


        <footer class="ecb-course-map-footer">

            <button type="button" class="ecb-course-map-cancel-button" (click)="closeLocationMap()">

                Close

            </button>


            <a class="ecb-course-map-google-button" [href]="googleMapsExternalUrl" target="_blank"
                rel="noopener noreferrer">

                <i class="bi bi-map" aria-hidden="true">
                </i>

                Open in Google Maps

            </a>

        </footer>

    </section>

</div>
<!-- End Course Location Map Modal -->


<!-- Start Classes Modal -->
<div class="ecb-course-map-overlay" *ngIf="
        isClassesModalOpen &&
        selectedShortCourse
    " (click)="closeClassesModal()">

    <section class="ecb-course-map-modal ecb-course-classes-modal" role="dialog" aria-modal="true"
        aria-labelledby="ecb-course-classes-title" (click)="$event.stopPropagation()">

        <!-- Start Classes Header -->
        <header class="ecb-course-classes-header">

            <div id="ecb-course-classes-title">
                Date &amp; Time
            </div>

            <div>
                Location
            </div>

            <button type="button" aria-label="Close available sessions" (click)="closeClassesModal()">

                <i class="bi bi-x-lg" aria-hidden="true">
                </i>

            </button>

        </header>
        <!-- End Classes Header -->


        <!-- Start Class Sessions -->
        <div class="ecb-course-classes-list">

            <article class="ecb-course-class-session" *ngFor="
                    let classSession of selectedCourseClasses
                ">

                <div class="ecb-course-class-date-column">

                    <p>
                        <i class="bi bi-calendar3" aria-hidden="true">
                        </i>

                        <strong>
                            {{
                            classSession.date
                            | date: 'dd/MM/yyyy'
                            }}
                        </strong>
                    </p>

                    <p>
                        <i class="bi bi-clock" aria-hidden="true">
                        </i>

                        <span>
                            {{ classSession.startTime }}
                            –
                            {{ classSession.endTime }}
                        </span>
                    </p>

                </div>


                <div class="ecb-course-class-location-column">

                    <p>
                        <i class="bi bi-geo-alt-fill" aria-hidden="true">
                        </i>

                        <strong>
                            {{ classSession.trainer }}
                        </strong>
                    </p>

                    <p>
                        {{ classSession.location }}
                    </p>

                </div>

            </article>


            <div class="ecb-course-details-empty" *ngIf="selectedCourseClasses.length === 0">

                No class sessions are currently available.

            </div>

        </div>
        <!-- End Class Sessions -->


        <footer class="ecb-course-map-footer">

            <button type="button" class="ecb-course-map-cancel-button" (click)="closeClassesModal()">

                Close

            </button>

        </footer>

    </section>

</div>
<!-- End Classes Modal -->

<!-- Start Units Modal -->
<div class="ecb-course-map-overlay" *ngIf="    isUnitsModalOpen &&     selectedShortCourse  "
    (click)="closeUnitsModal()">

    <section class="ecb-course-map-modal ecb-course-units-modal" role="dialog" aria-modal="true"
        aria-labelledby="ecb-course-units-title" (click)="$event.stopPropagation()">

        <!-- Start Units Header -->
        <header class="ecb-course-units-header">

            <div class="ecb-course-units-title">

                <i class="bi bi-book" aria-hidden="true">
                </i>

                <div>

                    <h3 id="ecb-course-units-title">
                        Units of Competency
                        ({{ selectedCourseUnits.length }})
                    </h3>

                    <p>
                        The following units will be assessed
                        as part of this course.
                    </p>

                </div>

            </div>


            <button type="button" class="ecb-course-map-close-button" aria-label="Close unit details"
                (click)="closeUnitsModal()">

                <i class="bi bi-x-lg" aria-hidden="true">
                </i>

            </button>

        </header>
        <!-- End Units Header -->


        <!-- Start Units Content -->
        <div class="ecb-course-units-content">

            <div class="ecb-course-units-list">

                <div class="ecb-course-unit-item" *ngFor="
                        let unit of selectedCourseUnits
                    ">

                    <p class="ecb-course-unit-text">
                        {{ unit.name }}
                        ({{ unit.code }})
                    </p>

                </div>


                <div class="ecb-course-details-empty" *ngIf="selectedCourseUnits.length === 0">

                    No unit information is currently available.

                </div>

            </div>

        </div>
        <!-- End Units Content -->


        <footer class="ecb-course-map-footer">

            <button type="button" class="ecb-course-map-cancel-button" (click)="closeUnitsModal()">

                Close

            </button>

        </footer>

    </section>

</div>
<!-- End Units Modal -->
<!-- Start Group Booking Modal -->
<div class="ecb-group-booking-overlay" *ngIf="isGroupBookingModalOpen" (click)="closeGroupBookingEnquiry()">

    <div class="ecb-group-booking-modal" role="dialog" aria-modal="true" aria-labelledby="groupBookingModalTitle"
        (click)="$event.stopPropagation()">

        <!-- Start Close Button -->
        <button type="button" class="ecb-group-booking-close" aria-label="Close" (click)="closeGroupBookingEnquiry()">

            <i class="bi bi-x-lg"></i>

        </button>
        <!-- End Close Button -->

        <!-- Start Modal Body -->
        <div class="ecb-group-booking-modal-body">

            <div class="row align-items-center g-4">

                <!-- Start Illustration Section -->
                <div class="col-12 col-lg-5">

                    <div class="ecb-group-booking-illustration">

                        <div class="ecb-group-booking-illustration-circle">

                            <div class="ecb-group-booking-calendar-icon">
                                <i class="bi bi-calendar2-check"></i>
                            </div>

                            <div class="ecb-group-booking-people">

                                <div class="ecb-group-booking-person ecb-group-booking-person-left">
                                    <i class="bi bi-person-fill"></i>
                                </div>

                                <div class="ecb-group-booking-person ecb-group-booking-person-main">
                                    <i class="bi bi-person-fill"></i>
                                </div>

                                <div class="ecb-group-booking-person ecb-group-booking-person-right">
                                    <i class="bi bi-person-fill"></i>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
                <!-- End Illustration Section -->

                <!-- Start Information Section -->
                <div class="col-12 col-lg-7">

                    <div class="ecb-group-booking-heading">

                        <div class="ecb-group-booking-heading-icon">
                            <i class="bi bi-people"></i>
                        </div>

                        <div>

                            <h2 id="groupBookingModalTitle">
                                Group Booking?
                            </h2>

                            <h3>
                                We’re Here to Help!
                            </h3>

                            <span></span>

                        </div>

                    </div>

                    <p class="ecb-group-booking-description">
                        Planning training for your team?
                        <br>
                        For group bookings (5 or more participants), please
                        contact our friendly team with your requirements.
                    </p>

                    <div class="ecb-group-booking-contact-card">

                        <a href="tel:0893580000" class="ecb-group-booking-contact-item">

                            <div class="ecb-group-booking-contact-icon">
                                <i class="bi bi-telephone"></i>
                            </div>

                            <div>

                                <h4>
                                    Call Us
                                </h4>

                                <strong>
                                    1300 322 486
                                </strong>

                                <p>
                                    Mon – Fri: 8:30am – 5:00pm
                                </p>

                            </div>

                        </a>

                        <a href="mailto:admin@ecbtraining.com.au" class="ecb-group-booking-contact-item">

                            <div class="ecb-group-booking-contact-icon">
                                <i class="bi bi-envelope"></i>
                            </div>

                            <div>

                                <h4>
                                    Email Us
                                </h4>

                                <strong>
                                    admin&#64;ecbtraining.com.au
                                </strong>

                                <p>
                                    We’ll get back to you as soon as possible.
                                </p>

                            </div>

                        </a>

                    </div>

                </div>
                <!-- End Information Section -->

            </div>

            <!-- Start Enquiry Requirements Section -->
            <section class="ecb-group-booking-requirements">

                <h3>
                    Please include the following details in your enquiry:
                </h3>

                <div class="row g-0">

                    <div class="col-12 col-sm-6 col-lg-3">

                        <div class="ecb-group-booking-requirement-item">

                            <div class="ecb-group-booking-requirement-icon">
                                <i class="bi bi-people"></i>
                            </div>

                            <span>
                                Number of Participants
                            </span>

                        </div>

                    </div>

                    <div class="col-12 col-sm-6 col-lg-3">

                        <div class="ecb-group-booking-requirement-item">

                            <div class="ecb-group-booking-requirement-icon">
                                <i class="bi bi-calendar3"></i>
                            </div>

                            <span>
                                Preferred Course and Date
                            </span>

                        </div>

                    </div>

                    <div class="col-12 col-sm-6 col-lg-3">

                        <div class="ecb-group-booking-requirement-item">

                            <div class="ecb-group-booking-requirement-icon">
                                <i class="bi bi-geo-alt"></i>
                            </div>

                            <span>
                                Training Location
                            </span>

                        </div>

                    </div>

                    <div class="col-12 col-sm-6 col-lg-3">

                        <div class="ecb-group-booking-requirement-item">

                            <div class="ecb-group-booking-requirement-icon">
                                <i class="bi bi-pencil-square"></i>
                            </div>

                            <span>
                                Any Other Requirements
                            </span>

                        </div>

                    </div>

                </div>

            </section>
            <!-- End Enquiry Requirements Section -->

        </div>
        <!-- End Modal Body -->

        <!-- Start Modal Footer -->
        <footer class="ecb-group-booking-modal-footer">

            <div class="ecb-group-booking-footer-icon">
                <i class="bi bi-hand-thumbs-up-fill"></i>
            </div>

            <div>

                <strong>
                    Thank you for choosing ECB Training.
                </strong>

                <p>
                    We look forward to supporting your team’s success!
                </p>

            </div>

        </footer>
        <!-- End Modal Footer -->

    </div>

</div>
<!-- End Group Booking Modal -->